import React, { useState, useCallback, useMemo, useContext, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import TableContainerMin from "../../../Components/Common/TableContainer";
import { useQuery, useQueryClient } from "react-query";
import { DeleteOutlined, EditOutlined,EyeOutlined,PlusCircleOutlined } from "@ant-design/icons";
import { Button, Modal, Spin } from "antd";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import toast from "react-hot-toast";
import "../../Styles/style.css";
import { deleteStatus, getStatus } from "../services/statusApi";
import AddEditStatusForm from "../component/AddEditStatus";
import DetailStatut from "../component/DetailStatus";

const Status = () => {
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  useEffect(() => {
    document.title = `Status | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  }, []);
  
  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isAffectModalOpen, setIsAffectModalOpen] = useState(false);
  const [selectedStatus, setselectedStatus] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [statusDelete, setstatusDelete] = useState("");

  const { isLoading, isError, error, data: status } = useQuery("status", getStatus);

  const toggleAddEditModal = useCallback((catalog = null) => {
    setselectedStatus(catalog);
    setIsAddEditModalOpen(prev => !prev);
    if (isDetailModalOpen) setIsDetailModalOpen(false);
    if (isAffectModalOpen) setIsAffectModalOpen(false);
  }, [isDetailModalOpen, isAffectModalOpen]);

  const handleEdit = (catalog) => {
    toggleAddEditModal(catalog);
  };

  const toggleDetailModal = useCallback((catalog = null) => {
    setselectedStatus(catalog);
    setIsDetailModalOpen(prev => !prev);
    if (isAddEditModalOpen) setIsAddEditModalOpen(false);
    if (isAffectModalOpen) setIsAffectModalOpen(false);
  }, [isAddEditModalOpen, isAffectModalOpen]);

  const handleDetail = (catalog) => {
    toggleDetailModal(catalog);
  };

  const toggleAffectModal = useCallback((catalog = null) => {
    setselectedStatus(catalog);
    setIsAffectModalOpen(prev => !prev);
    if (isAddEditModalOpen) setIsAddEditModalOpen(false);
    if (isDetailModalOpen) setIsDetailModalOpen(false);
  }, [isAddEditModalOpen, isDetailModalOpen]);

  const handleAffect = (catalog) => {
    toggleAffectModal(catalog);
  };

  const handleDelete = async (catalogId) => {
    try {
      await deleteStatus(catalogId);
      queryClient.invalidateQueries("status");
      toast.success("Le status a été supprimé avec succès 🎉");
    } catch (error) {
      console.error("Error deleting status:", error);
      toast.error(`😔 Erreur lors de la suppression du status : ${error?.message || error}`);
    } finally {
      setDeleteConfirmModal(false);
    }
  };

  const openDeleteConfirmModal = (catalogId) => {
    const catalogToDelete = status.find(catalog => catalog.id === catalogId);
    if (catalogToDelete) {
      setDeleteTargetId(catalogId);
      setstatusDelete(catalogToDelete.name);
      setDeleteConfirmModal(true);
    }
  };

  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModal(false);
  };

  const columns = useMemo(() => [
    { Header: "Nom", accessor: "name", Cell: ({ row }) => ( <div>{row.original.name || "-"}</div>),filterable: false },
    { Header: "Type", accessor: "type", Cell: ({ row }) => ( <div>{row.original.type || "-"}</div>), filterable: false },
    { Header: "Description", accessor: "description", Cell: ({ row }) => ( <div>{row.original.type || "-"}</div>), filterable: false },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Button title="Détail d'un status" size="sm" onClick={() => handleDetail(row.original)} className="btn btn-soft-info">
            <EyeOutlined />
          </Button>
          <Button title="Modifier le status" size="sm" onClick={() => handleEdit(row.original)} className="btn btn-soft-warning">
            <EditOutlined />
          </Button>
          <Button title="Supprimer le status" size="sm" onClick={() => openDeleteConfirmModal(row.original.id)} className="btn btn-soft-danger">
            <DeleteOutlined />
          </Button>
        </div>
      ),
      filterable: false,
    },
  ], [handleEdit, openDeleteConfirmModal, handleDetail, handleAffect]);

  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      {tabs.map((tab) => (
        <Button key={tab} onClick={() => handleTabChange(tab)} className={`btn ${activeTab == tab ? 'active-tab' : 'btn-light'}`}>
          {tab}
        </Button>
      ))}
    </div>
  );

  const HeaderTable = () => (
    <div className="d-flex justify-content-between align-items-center w-100">
      <div className="d-flex gap-3">{renderTabs()}</div>
      <Button type="button" className="active-tab" icon={<PlusCircleOutlined />} title="Status" onClick={() => toggleAddEditModal(null)}>
        {" "} Ajouter un status
      </Button>
    </div>
  );

  const tabs = ['Tous', 'Véhicule', 'Inspection', 'Utilisateurs'];
  const [activeTab, setActiveTab] = useState('Tous');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const filteredStatus = useMemo(() => {
    if (!status) return error?.message || [];
    switch (activeTab) {
      case 'Utilisateurs':
        return status.filter(v => v.category === 'Utilisateur');
      case 'Véhicule':
        return status.filter(v => v.category === 'Véhicule');
      case 'Inspection':
        return status.filter(v => v.category === 'Inspection');
      default:
        return status;
    }
  }, [status, activeTab]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page="Status" history={history} />
          <Row>
            <Col>
              <Card id="contactList">
                <CardHeader>
                  <HeaderTable />
                </CardHeader>
                <CardBody className="pt-0">
                  <TableContainerMin
                    columns={columns}
                    data={filteredStatus}
                    isGlobalSearch={true}
                    isGlobalFilter={true}
                    customPageSize={5}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light"
                    HeaderTable={HeaderTable}
                  />
                  {isLoading && !isError && (
                    <div className="text-center">
                      Chargement, Merci de patienter ...  <Spin />
                    </div>
                  )}
                  {filteredStatus && filteredStatus.length === 0 && !isLoading && (
                    <div className="text-center">Aucun status à afficher pour le moment.</div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <AddEditStatusForm
            modal={isAddEditModalOpen}
            setModal={setIsAddEditModalOpen}
            toggle={toggleAddEditModal}
            selectedStatus={selectedStatus}
          />

          <DetailStatut
            modal={isDetailModalOpen}
            setModal={setIsDetailModalOpen}
            toggle={toggleDetailModal}
            selectedStatus={selectedStatus}
          />

          <Modal
            title="Confirmer la suppression"
            visible={deleteConfirmModal}
            onCancel={closeDeleteConfirmModal}
            footer={[
              <Button key="cancel" onClick={closeDeleteConfirmModal}>
                Annuler
              </Button>,
              <Button key="delete" type="danger" onClick={() => handleDelete(deleteTargetId)}>
                Supprimer
              </Button>
            ]}
          >
            <p>Êtes-vous sûr de vouloir supprimer le statut {statusDelete} ?</p>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Status;
